/* Geurvinder caasi.nl
 *
 * De AI-aanroep zat hier tot 20 augustus 2026 rechtstreeks in, inclusief zes
 * Groq API-sleutels. Dit bestand is een thema-asset en dus door iedereen van
 * de Shopify-CDN te downloaden, dus die sleutels lagen op straat. De aanroep
 * en de systeemprompt staan nu op de server (crm.caasi.nl/geurvinder/vertaal);
 * hier blijft alleen over: vraag opsturen, filters ontvangen, URL bouwen.
 *
 * Elke URL die we bouwen krijgt filter.v.availability=1. Zonder die parameter
 * bestond een resultaat voor 58 tot 71 procent uit uitverkochte parfums.
 */
(function(){
'use strict';

var ENDPOINT='https://crm.caasi.nl/geurvinder/vertaal';
var TIMEOUT=14000;

var input=document.getElementById('gv-input');
var btn=document.getElementById('gv-btn');
var disambig=document.getElementById('gv-disambig');
if(!input||!btn)return;

/* Taalbewuste adressen uit het thema (/en/... op de Engelse site). */
var ZOEK=input.getAttribute('data-zoek')||'/search';
var COLL=input.getAttribute('data-collecties')||'/collections';

function metVoorraad(url){
  return url+(url.indexOf('?')>-1?'&':'?')+'filter.v.availability=1';
}

/* Terugval als de vertaling niet lukt: gewoon trefwoordzoeken, maar wel
   alleen door wat er op voorraad ligt. */
function zoekUrl(vraag){
  return metVoorraad(ZOEK+'?q=parfum+'+encodeURIComponent(vraag)+'&type=product');
}

function buildUrl(r){
  /* Collectiefilters zijn preciezer dan tekstzoeken. Alleen als er puur een
     zoekterm is (bijvoorbeeld "vanille" of "eau de toilette") zonder geurtype
     of doelgroep, valt hij terug op de zoekpagina. */
  var heeftFilters=(r.geurtype&&r.geurtype.length)||r.doelgroep||r.merk||
                   (r.prijs_min&&r.prijs_min>0)||(r.prijs_max&&r.prijs_max>0);
  if(r.zoekterm&&!heeftFilters){
    return metVoorraad(ZOEK+'?q='+encodeURIComponent('parfum '+r.zoekterm)+'&type=product');
  }
  var p=[];
  if(r.geurtype&&r.geurtype.length){
    r.geurtype.forEach(function(g){p.push('filter.p.m.caasi.geurtype='+encodeURIComponent(g));});
  }
  if(r.doelgroep){p.push('filter.p.m.caasi.doelgroep='+encodeURIComponent(r.doelgroep));}
  if(r.merk){p.push('filter.p.vendor='+encodeURIComponent(r.merk));}
  if(r.prijs_min&&r.prijs_min>0){p.push('filter.v.price.gte='+r.prijs_min);}
  if(r.prijs_max&&r.prijs_max>0){p.push('filter.v.price.lte='+r.prijs_max);}
  p.push('filter.v.availability=1');
  return COLL+'/parfum?'+p.join('&');
}

function vraagVertaling(vraag,klaar){
  var afgebroken=false;
  var timer=setTimeout(function(){afgebroken=true;klaar(null);},TIMEOUT);

  fetch(ENDPOINT,{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({q:vraag})
  }).then(function(r){
    return r.ok?r.json():null;
  }).then(function(data){
    if(afgebroken)return;
    clearTimeout(timer);
    klaar(data&&!data.fout?data:null);
  }).catch(function(){
    if(afgebroken)return;
    clearTimeout(timer);
    klaar(null);
  });
}

function bezig(aan){
  if(aan){btn.textContent=btn.getAttribute('data-tekst-bezig')||'Even zoeken...';btn.disabled=true;input.disabled=true;}
  else{btn.textContent=btn.getAttribute('data-tekst-zoek')||'Zoek';btn.disabled=false;input.disabled=false;}
}

function doeZoek(){
  var vraag=input.value.trim();
  if(!vraag)return;
  if(disambig)disambig.style.display='none';
  bezig(true);

  vraagVertaling(vraag,function(resultaat){
    bezig(false);
    if(!resultaat){window.location.href=zoekUrl(vraag);return;}
    var bruikbaar=(resultaat.geurtype&&resultaat.geurtype.length)||resultaat.doelgroep||
                  resultaat.merk||resultaat.prijs_min||resultaat.prijs_max||resultaat.zoekterm;
    window.location.href=bruikbaar?buildUrl(resultaat):zoekUrl(vraag);
  });
}

btn.addEventListener('click',doeZoek);
input.addEventListener('keydown',function(e){if(e.key==='Enter')doeZoek();});

document.querySelectorAll('#gv-pills .gv-pill[data-url]').forEach(function(pill){
  pill.addEventListener('click',function(){window.location.href=this.getAttribute('data-url');});
});

var sluit=document.getElementById('gv-disambig-close');
if(sluit){
  sluit.addEventListener('click',function(){
    if(disambig)disambig.style.display='none';
    input.value='';
    input.focus();
  });
}
})();
